import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Edit from '@material-ui/icons/Edit'
import {Objects} from "components";

export default class ScoreName extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Scores_Names._name, API.RequestType.READ);
		super(props, model);
		this.state.limit = 16;
		this.state.parts = [];
		this.state.modalPartEdit = false;
	}

	fetchScoreParts = async () => {
		let model = new API.BuildClass(Types.Scores_Parts._name, API.RequestType.READ_ALL);
		this.read = 'GET_ALL';
		model.filter = {
			'filterName': this.props.id ?? null
		}
		let res = await model.submit(null, this.read);
		this.setState({
			parts: res.items
		});
	}

	fetchData = async (state) => {
		this.state.limit = 15;
		this.state.sorted = [];
		this.state.page = 0;
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.state.filter.id = this.props.id ?? null;
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(state);
			this.fetchScoreParts();
		}, 100);
	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	render() {
		const {data, pages, limit, loading, parts} = this.state;
		const columns =
			[
				{
					Header: "Metric Name",
					accessor: "metric_name",
				},
				{
					Header: "Metric Type",
					accessor: "metric_type",
				},
				{
					Header: "Metric Info / Tiers",
					id: "metric_info",
					accessor: obj => (['Length', 'Amount'].includes(obj.metric_type) ? obj.metric_info.replaceAll(',', ' => ').replaceAll('|', ', ') : obj.metric_info)
				},
				{
					Header: "",
					id: "edit",
					className: "button-cell",
					filterable: false,
					sortable: false,
					width: 45,
					accessor: obj => obj.pkey,
					Cell: props => {
						return (
							<span>
								<Button color="green-meadow" size={"sm"} block={true} onClick={() => {
									this.setState({selectedPart: props.original.pkey})
									this.handleToggleModal('modalPartEdit')
								}}>
									<Edit fontSize={'small'}/>
								</Button>
							</span>
						);
					}
				},
			]
		return (
			<div className={'box-body'}>

				<div className={'flex-row'} style={{display: 'flex', alignItems: 'center'}}>
					<div className={'pr-2 font-weight-bold'}>
						{data[0]?.name} Overall Weight:&nbsp;{this.state.isEditing ? <input value={this.state.newWeight ?? data[0]?.weight} onChange={(event) => {this.setState({newWeight: event.currentTarget.value})}}/> : data[0]?.weight}
					</div>
					<Button color={!!this.state.isEditing ? 'blue-hoki' : 'green-meadow'} size={'sm'} block={false} onClick={async () => {
						if(!!this.state.isEditing) {
							let model = new API.BuildClass(Types.Scores_Names._name, API.RequestType.UPDATE);
							this.read = 'POST';
							model.object.pkey = window.location.href.split('-')[1];
							model.object.weight = this.state.newWeight;
							model.object.name = data[0]?.name
							await model.submit(null, this.read);
							this.setState({
								isEditing: false,
								newWeight: null
							});
							await this.fetchData(this.state);
						} else {
							this.setState({
								isEditing: true
							})
						}
					}}>
						<Edit fontSize={'small'}/>
					</Button>
				</div>

				<Framework.Elements.UniversalModal
					name={"Metric"}
					object={Objects.ScorePart}
					history={this.props.history}
					toggle={this.state.modalPartEdit}
					reportClose={() => {
						this.setState({selectedPart: false, modalPartEdit: false})
					}}
					afterSave={() => {
						this.fetchData(this.state)
					}}
					hideGoTo={true}
					id={this.state.selectedPart}
				/>
				<Card>
					<CardContent>
						<ReactTable
							key={this.state.key}
							columns={columns}
							onPageSizeChange={this.onPageSizeChange}
							pageSize={limit}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={parts}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							defaultSorted={[
								{
									id: 'ranking'
								}
							]}
							showPagination={true}
							defaultPageSize={limit}
							className="-striped -highlight"
						/>

						<Framework.Elements.LoadingSpinner isLoading={loading}/>
					</CardContent>
				</Card>
			</div>
		)
	}
}
